import axios from "axios";
import { SERVER_BASE_ADDRESS } from "./const";
import { getToken, saveAuth } from "./authentication";

const instance = axios.create({
  baseURL: SERVER_BASE_ADDRESS,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

instance.interceptors.request.use(
  function (config) {
    if (getToken() !== null) {
      config.headers = {
        // "Content-Type": "application/json",
        Authorization: "Token " + getToken(),
      };
    }
    let url = config.url;
    if (!url) {
      url = "";
    }
    url = url.toLowerCase();
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response !== undefined && error.response.status === 401) {
      saveAuth(undefined);
    } else if (error.response.data.error) {
      error.message = error.response.data.error;
    } else {
      for (let x in error.response.data) {
        error.message = error.response.data[`${x}`][0];
      }
    }
    return Promise.reject(error);
  }
);

export const requestWithCustomToken = (
  method,
  url,
  token,
  data = null,
  config = {}
) => {
  return instance({
    method,
    url,
    data,
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Token ${token}`,
    },
  });
};

export default instance;
